import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=4b78678c&"
import script from "./Help.vue?vue&type=script&lang=js&"
export * from "./Help.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b78678c')) {
      api.createRecord('4b78678c', component.options)
    } else {
      api.reload('4b78678c', component.options)
    }
    module.hot.accept("./Help.vue?vue&type=template&id=4b78678c&", function () {
      api.rerender('4b78678c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Alerts/Sections/Help.vue"
export default component.exports